import { useContext } from 'react'
import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut, faTrashAlt } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@domain-group/javascript-utils'
import { generateRedirectUrl } from '@domain-group/javascript-utils'

import PageContext from '@contexts/pageContext'

import usePublicationPaginationRule from '@hooks/usePublicationPaginationRule'
import { generateUrls } from '@hooks/usePaginationRule'

import { PublicationPaginationRuleModel } from '@models/types'

const confirmDelete = (
  deletePublicationPaginationRule: (payload: HandleCallbackActionParams) => Promise<object>,
  deleteFn: () => void,
) => {
  const publicationPaginationRulePayload = {
    callbacks: {
      action: deleteFn,
    },
    toastText: 'Pagination Rule Removed',
  }

  swal
    .fire({
      title: 'Remove Pagination Rule?',
      text: 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, remove it.',
      confirmButtonColor: '#DD6B55',
    })
    .then(({ value }) => {
      if (value){
        // @ts-expect-error TS2345
        deletePublicationPaginationRule(publicationPaginationRulePayload)
      }
    })
}

const PublicationPaginationRuleActions = (
  props: { publicationPaginationRule: Partial<PublicationPaginationRuleModel> },
) => {
  const { publicationPaginationRule } = props

  const { editPaginationRuleUrl } = generateUrls({ id: publicationPaginationRule.pagination_rule_id })

  const {
    callbacks: {
      deletePublicationPaginationRule: deleteFn,
    },
  } = usePublicationPaginationRule(publicationPaginationRule)

  const {
    callbacks: { deletePublicationPaginationRule },
  } = useContext(PageContext)

  return (
    <Box justifyContent="center">
      <Link
        greyLink
        onClick={() => confirmDelete(deletePublicationPaginationRule, deleteFn)}
        textProps={{ marginRight: 'medium' }}
      >
        <FontAwesomeIcon icon={faTrashAlt} />
      </Link>

      <Link
        greyLink
        href={`${editPaginationRuleUrl}?redirect=${generateRedirectUrl()}`}
      >
        <FontAwesomeIcon icon={faSignOut} />
      </Link>
    </Box>
  )
}

export default PublicationPaginationRuleActions
